import { c as _c } from "react/compiler-runtime";
import { useInView, useMotionValue, useSpring } from 'motion/react';
import { useEffect, useRef } from 'react';
type CounterProps = {
  value: number;
  direction?: 'up' | 'down';
} & React.ComponentProps<'span'>;
export function Counter(props) {
  const $ = _c(18);
  let rest;
  let t0;
  let value;
  if ($[0] !== props) {
    ({
      value,
      direction: t0,
      ...rest
    } = props);
    $[0] = props;
    $[1] = rest;
    $[2] = t0;
    $[3] = value;
  } else {
    rest = $[1];
    t0 = $[2];
    value = $[3];
  }
  const direction = t0 === undefined ? "up" : t0;
  const ref = useRef(null);
  const motionValue = useMotionValue(direction === "down" ? value : 0);
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      damping: 100,
      stiffness: 300
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const springValue = useSpring(motionValue, t1);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      once: true,
      margin: "-100px"
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const isInView = useInView(ref, t2);
  let t3;
  let t4;
  if ($[6] !== direction || $[7] !== isInView || $[8] !== motionValue || $[9] !== value) {
    t3 = () => {
      if (isInView) {
        motionValue.set(direction === "down" ? 0 : value);
      }
    };
    t4 = [motionValue, isInView, direction, value];
    $[6] = direction;
    $[7] = isInView;
    $[8] = motionValue;
    $[9] = value;
    $[10] = t3;
    $[11] = t4;
  } else {
    t3 = $[10];
    t4 = $[11];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[12] !== springValue || $[13] !== value) {
    t5 = () => {
      if (ref.current && value === 0) {
        ref.current.textContent = "0";
        return;
      }
      springValue.on("change", latest => {
        if (ref.current) {
          ref.current.textContent = latest.toFixed(0);
        }
      });
    };
    t6 = [springValue, value];
    $[12] = springValue;
    $[13] = value;
    $[14] = t5;
    $[15] = t6;
  } else {
    t5 = $[14];
    t6 = $[15];
  }
  useEffect(t5, t6);
  let t7;
  if ($[16] !== rest) {
    t7 = <span ref={ref} {...rest}>0</span>;
    $[16] = rest;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}